import { formatPhoneNumber } from "react-phone-number-input";
import { FIELD_TYPES, TEXT_NOTIFICATION_VALUES } from "../../utils/constants";

export const getFieldData = (fields = [], fieldName) => {
  let fieldData = {};

  fields.forEach((field, index) => {
    if (field.name === fieldName) {
      fieldData = { field, index };
    }
    if (field?.type === FIELD_TYPES.container) {
      const innerField = getFieldData(
        field?.fieldLayouts?.[0]?.containerFields,
        fieldName
      );
      if (innerField.index >= 0) {
        fieldData = innerField;
      }
    }
  });

  return fieldData;
};

export const getLabeledText = (fieldText, data) =>
  `${fieldText.split(":")[0]}: ${data}`;

export const getOtherPhoneNumber = (values, fieldName, customFieldName) => {
  if (
    values[fieldName] === TEXT_NOTIFICATION_VALUES.addNew &&
    values[customFieldName]
  ) {
    const numberObject = values[customFieldName]?.countryCode
      ? values[customFieldName]
      : JSON.parse(values[customFieldName]);
    const localizedFormatNumber = formatPhoneNumber(
      numberObject.phoneNumber?.includes("+")
        ? numberObject.phoneNumber
        : `+${numberObject.countryCode}${numberObject.phoneNumber}`
    );
    return `+${numberObject.countryCode} ${localizedFormatNumber}`;
  } else {
    return values[fieldName];
  }
};

export const paramsIncludes = (params, hasParam) =>
  params.split("|").includes(hasParam);
